import React from "react";

import { IconButton, Tooltip } from "@mui/material";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { ChatBubbleOutline, ChatBubble } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

import useVideoContext from "../../hooks/useVideoContext/useVideoContext";

const useStyles = makeStyles(() =>
  createStyles({
    iconButton: {
      padding: 0,
      marginLeft: "0.7rem",
      backgroundColor: "transparent",
      "&:hover": {
        backgroundColor: "transparent",
      },
      "&:disabled": {
        opacity: 0.8,
      },
    },
    iconPointer: {
      cursor: "pointer",
      fontSize: "18px",
    },
  })
);

export default function ToggleCommunication(props: { toggle: boolean; setToggle: () => void }) {
  const { t: translate } = useTranslation();
  const classes = useStyles();
  const { room, participantsAllowed } = useVideoContext();
  const { toggle, setToggle } = props;

  const renderIcons = () => {
    if (toggle) return <ChatBubble htmlColor="#308CDB" className={classes.iconPointer} />;

    return <ChatBubbleOutline htmlColor="#475467" className={classes.iconPointer} />;
  };

  return (
    <Tooltip title={translate("openCommunication")}>
      <span>
        <IconButton
          className={classes.iconButton}
          onClick={() => setToggle()}
          disabled={!room || participantsAllowed?.length === 0}
          data-cy="videoSurveyToggleCommunicationIcon"
          data-cy-communication
        >
          {renderIcons()}
        </IconButton>
      </span>
    </Tooltip>
  );
}
